import { Modal } from "./AdministrationFields";
import { FIELD_LABELS } from "../model/administrationConstants";
import { displayMergeValue } from "../model/administrationRules";
import { primaryButtonStyle, secondaryButtonStyle } from "../styles/administrationModalStyles";
import { mergeChoiceStyle, mergeConflictFieldStyle } from "../styles/administrationStyles";

export function MergeConflictModal({ conflict, saving, onChoice, onCancel, onConfirm }) {
    return (
        <Modal title="Des modifications ont été faites entre-temps" onClose={onCancel} width={760}>
            <p style={{ marginTop: 0, color: "#475569", lineHeight: 1.5 }}>
                Les autres champs ont été fusionnés automatiquement. Pour les champs ci-dessous,
                choisissez la valeur à conserver.
            </p>
            <div style={{ display: "grid", gap: "14px", maxHeight: "55vh", overflowY: "auto" }}>
                {conflict.conflicts.map(field => (
                    <fieldset key={field} style={mergeConflictFieldStyle}>
                        <legend style={{ padding: "0 6px", fontWeight: 700, color: "#1e293b" }}>
                            {FIELD_LABELS[field] || field}
                        </legend>
                        <label style={mergeChoiceStyle(conflict.choices[field] === "mine")}>
                            <input
                                type="radio"
                                name={`merge-${field}`}
                                checked={conflict.choices[field] === "mine"}
                                onChange={() => onChoice(field, "mine")}
                            />
                            <span><strong>Conserver ma valeur</strong><br />{displayMergeValue(conflict.local[field])}</span>
                        </label>
                        <label style={mergeChoiceStyle(conflict.choices[field] === "other")}>
                            <input
                                type="radio"
                                name={`merge-${field}`}
                                checked={conflict.choices[field] === "other"}
                                onChange={() => onChoice(field, "other")}
                            />
                            <span><strong>Conserver la valeur enregistrée depuis votre dernier chargement</strong><br />{displayMergeValue(conflict.remote[field])}</span>
                        </label>
                    </fieldset>
                ))}
            </div>
            <div style={{ display: "flex", justifyContent: "flex-end", gap: "8px", marginTop: "20px" }}>
                <button type="button" onClick={onCancel} disabled={saving} style={secondaryButtonStyle}>Annuler</button>
                <button type="button" onClick={onConfirm} disabled={saving} style={primaryButtonStyle}>
                    {saving ? "Enregistrement…" : "Fusionner et enregistrer"}
                </button>
            </div>
        </Modal>
    );
}
